<template>
  <b-container fluid class="col-md-6">
    <b-row>
      <h2 style="margin-left: 15px">{{title}}</h2>
      <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
      <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
    </b-row>
    <b-row style="min-height: 360px;">
      <div>
        <b-table striped hover outlined
                 style="line-height:0.6;"
                 id="filterTable"
                 :items="filters"
                 :fields="filterfields"
                 :select-mode="'single'"
                 sticky-header="330px"
                 no-select-on-click
                 ref="filtersTableRef"
                 selectable
                 @row-clicked="filtersSelected">
        </b-table>
      </div>
      <div class="errorOverviewColumnMiddle">
        <textarea v-model="validationMessage" id="validationMessage"></textarea>
      </div>
    </b-row>
    <b-row class="errorOverviewRow">
      <div class="errorViewEditor">
        <b-form @submit="save">
          <div class="row">
            <div class="col-6">
              <h4>
                Factuurgegevens
              </h4>
              <b-form-group id="billingCountryCode" label-for="billingCountryCodeInput" label="Landcode">
                <b-form-input id="billingCountryCodeInput" type="text" v-model="selectedOrder.billingCountryCode" />
              </b-form-group>
              <b-form-group id="billingCity" label-for="billingCityInput" label="Plaats">
                <b-form-input id="billingCityInput" type="text" v-model="selectedOrder.billingCity" />
              </b-form-group>
              <b-form-group id="billingStreet" label-for="billingStreetInput" label="Straat">
                <b-form-input id="billingStreetInput" type="text" v-model="selectedOrder.billingStreet" />
              </b-form-group>
              <b-form-group id="billingHouseNumber" label-for="billingHouseNumberInput" label="Huisnummer">
                <b-form-input id="billingHouseNumberInput" type="text" v-model="selectedOrder.billingHouseNumber" />
              </b-form-group>
              <b-form-group id="billingHouseNumberAddition" label-for="billingHouseNumberAdditionInput" label="Huisnummertoevoeging">
                <b-form-input id="billingHouseNumberAdditionInput" type="text" v-model="selectedOrder.billingHouseNumberAddition" />
              </b-form-group>
              <b-form-group id="billingZipcode" label-for="billingZipcodeInput" label="Postcode">
                <b-form-input id="billingZipcodeInput" type="text" v-model="selectedOrder.billingZipCode" />
              </b-form-group>
              <a :href="'https://www.google.com/maps/place/' + selectedOrderBillingAddress" target="_blank">Google Maps</a>
            </div>
            <div class="col-6">
              <h4>
                Verzendgegevens
              </h4>
              <b-form-group id="shippingCountryCode" label-for="shippingCountryCodeInput" label="Landcode">
                <b-form-input id="shippingCountryCodeInput" type="text" v-model="selectedOrder.shippingCountryCode" />
              </b-form-group>
              <b-form-group id="shippingCity" label-for="shippingCityInput" label="Plaats">
                <b-form-input id="shippingCityInput" type="text" v-model="selectedOrder.shippingCity" />
              </b-form-group>
              <b-form-group id="shippingStreet" label-for="shippingStreetInput" label="Straat">
                <b-form-input id="shippingStreetInput" type="text" v-model="selectedOrder.shippingStreet" />
              </b-form-group>
              <b-form-group id="shippingHouseNumber" label-for="shippingHouseNumberInput" label="Huisnummer">
                <b-form-input id="shippingHouseNumberInput" type="text" v-model="selectedOrder.shippingHouseNumber" />
              </b-form-group>
              <b-form-group id="shippingHouseNumberAddition" label-for="shippingHouseNumberAdditionInput" label="Huisnummertoevoeging">
                <b-form-input id="shippingHouseNumberAdditionInput" type="text" v-model="selectedOrder.shippingHouseNumberAddition" />
              </b-form-group>
              <b-form-group id="shippingZipcode" label-for="billingZipcodeInput" label="Postcode">
                <b-form-input id="billingZipcodeInput" type="text" v-model="selectedOrder.shippingZipCode" />
              </b-form-group>
              <a :href="'https://www.google.com/maps/place/' + selectedOrderShippingAddress" target="_blank">Google Maps</a>
            </div>
          </div>
          <b-button id="save" style="margin-top: 15px; margin-left: 10px;" @click="save" :disabled="selectedId == ''">Opslaan</b-button>
        </b-form>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'
  import * as CodeMirror from 'codemirror';
  import 'codemirror/lib/codemirror.css';
  import 'codemirror/theme/mdn-like.css';
  import 'codemirror/mode/javascript/javascript';
  import 'codemirror/mode/xml/xml';

  export default {
    name: 'OrderOverview',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Te valideren orders',
        loading: false,
        errors: [],
        selectedOrder: {},
        selectedOrderShippingAddress: '',
        selectedOrderBillingAddress: '',
        filters: [],
        selectedId: '',
        selectedError: {},
        selectedFilter: {},
        validationMessage: "",
        selectedPayload: "",
        confirmed: false,
        itemSaved: false,
        fields: [
          {
            key: 'webOrderID',
            label: 'Id',
            class: 'tablefont',
            sortable: true,
          },
          {
            key: 'reference',
            label: 'Referentie',
            class: 'tablefont',
          },
          {
            key: 'shippingMethod',
            label: 'Verzendmethode',
            class: 'tablefont',
          },
        ],
        filterfields: [
          {
            key: 'webshop',
            label: 'Webshop',
            class: 'typeColumn tablefont'
          },
          {
            key: 'reference',
            label: 'Referentie',
            tdClass: 'text-right',
            class: 'amountColumn tablefont'
          },
          {
            key: 'shippingMethod',
            label: 'Verzendmethode',
            tdClass: 'text-right',
            class: 'typeColumn tablefont'
          },
          {
            key: 'orderDate',
            label: 'Orderdatum',
            tdClass: 'text-right',
            formatter: 'formatDateAssigned',
            class: 'amountColumn tablefont'
          }
        ],
        filterOn: ['reference']
      };
    },
    mounted() {
      this.validationMessage = CodeMirror.fromTextArea(document.getElementById('validationMessage'), {
        lineNumbers: true,
        indentWithTabs: true,
        readOnly: true,
        theme: 'mdn-like',
        value: String,
      })
    },
    created: function () {

      // duplicate of this code exists in save()
      this.loading = true;
      this.$api.get('order/GetOrdersToValidate')
        .then((response) => {
          this.filters = response.data
        })
        .catch((error) => {
          this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de te valideren orders.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    computed: {
    },
    methods: {
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      async save() {
        if (await confirm('Weet u zeker dat u dit record wilt opslaan en verwerken?')) {
          this.loading = true;
          this.$api.post('order/save', this.selectedOrder)
            .then(() => {
              this.selectedId = '';
              this.selectedOrder = {};
              this.selectedOrderShippingAddress = '';
              this.selectedOrderBillingAddress = '';
              this.spliceLists();
              this.resetTables();


              // Duplicate of created()
              this.loading = true;
              this.$api.get('order/GetOrdersToValidate')
                .then((response) => {
                  this.filters = response.data
                })
                .catch((error) => {
                  this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de te valideren orders.')
                })
                .finally(() => {
                  this.loading = false
                })
              //End of duplicate
            })
            .catch((error) => {
              this.handleHttpError(error, 'Er ging iets fout bij bij het opslaan.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      async onSelectionChanged(item, index, event) {

      },
      filtersSelected(item, index, event) {
        this.selectedFilter = item

        this.selectedId = item.webOrderID;
        this.$refs.filtersTableRef.selectRow(index);
        this.$api.get('order/getorder/' + item.webOrderID)
          .then((response) => {
            this.resetTables()
            this.validationMessage.setValue(response.data.validationMessage)
            this.selectedOrder = response.data;

            this.selectedOrderBillingAddress = '';
            this.selectedOrderShippingAddress = '';
            if (this.selectedOrder.billingStreet != null) {
              this.selectedOrderBillingAddress += this.selectedOrder.billingStreet;
            }

            if (this.selectedOrder.billingHouseNumber != null) {
              this.selectedOrderBillingAddress += ' ' + this.selectedOrder.billingHouseNumber;
            }

            if (this.selectedOrder.billingHouseNumberAddition != null) {
              this.selectedOrderBillingAddress += this.selectedOrder.billingHouseNumberAddition;
            }

            if (this.selectedOrder.billingZipCode != null) {
              this.selectedOrderBillingAddress += ', ' + this.selectedOrder.billingZipCode;
            }

            if (this.selectedOrder.billingCity != null) {
              this.selectedOrderBillingAddress += ', ' + this.selectedOrder.billingCity;
            }





            if (this.selectedOrder.shippingStreet != null) {
              this.selectedOrderShippingAddress += this.selectedOrder.shippingStreet;
            }

            if (this.selectedOrder.shippingHouseNumber != null) {
              this.selectedOrderShippingAddress += ' ' + this.selectedOrder.shippingHouseNumber;
            }

            if (this.selectedOrder.shippingHouseNumberAddition != null) {
              this.selectedOrderShippingAddress += this.selectedOrder.shippingHouseNumberAddition;
            }

            if (this.selectedOrder.shippingZipCode != null) {
              this.selectedOrderShippingAddress += ', ' + this.selectedOrder.shippingZipCode;
            }

            if (this.selectedOrder.shippingCity != null) {
              this.selectedOrderShippingAddress += ', ' + this.selectedOrder.shippingCity;
            }
          })
          .catch((error) => {
            console.log(error);
            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de te valideren order.')
          })
        //.finally(() => {
        //  this.loading = false
        //})
      },
      formatDateAssigned(value) {
        if (value === null || value === "") {
          return ""
        }
        var date = new Date(value)
        var formattedDate = date.toLocaleDateString() + " " + date.toLocaleTimeString()
        return formattedDate;
      },
      spliceLists() {
        var index = this.errors.indexOf(this.selectedError);
        if (index > -1) {
          this.errors.splice(index, 1);
        }

        var filterIndex = this.filters.indexOf(this.selectedFilter)
        if (filterIndex > -1) {
          this.filters[filterIndex].amount = this.filters[filterIndex].amount - 1;
          if (this.filters[filterIndex].amount < 1) {
            this.filters.splice(filterIndex, 1);
          }
        }
        this.$refs.filtersTableRef.refresh();
      },
      resetTables() {
        this.itemSaved = true
        this.validationMessage.setValue('')
      }
    }
  }
</script>
<style>
  .tablefont {
    font-size: small;
  }

  .cm-s-mdn-like .cm-string {
    font-size: small;
    color: #07a;
    font-style: italic;
  }

  .CodeMirror {
    line-height: 1.0;
  }

  .amountColumn {
    text-align: end
  }

  .typeColumn {
    overflow: hidden;
    max-width: 230px;
  }
</style>



// WEBPACK FOOTER //
// src/components/orders/OrderOverview.vue